export default __webpack_public_path__ + "static/media/001-barbecue.e3d38f50.svg";